import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { Link } from "react-router-dom";
// icon
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";

import { auth } from "../../helpers";
import { login } from "../../services/Auth";
import crypto from "crypto-js";
import { uniqueDeviceId } from "../../services/Firebase";

const Login = ({ location }) => {
  const [email, setIdentification] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: false, password: false });
  const [is_visible, setIsVisible] = useState(false);
  const dispatch = useDispatch();

  const isAuthenticated = useSelector(auth.checkIfAuthenticated);

  const handleLogin = (event) => {
    event.preventDefault();
    let canSubmit = true;

    if (email.trim() === "") {
      setErrors({ ...errors, email: true });
      canSubmit = false;
    }
    // eslint-disable-next-line
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]+$/.test(email.trim())) {
      setErrors({ ...errors, email: true });
      canSubmit = false;
    }

    if (password.trim() === "") {
      setErrors((state) => {
        return { ...state, password: true };
      });
      canSubmit = false;
    }

    // generate device id
    let device_id = uniqueDeviceId();

    if (canSubmit) {
      const formData = {
        data: crypto.AES.encrypt(
          JSON.stringify({ email, password, device_id }),
          process.env.REACT_APP_CIPHER_SECRET || "secret_ninaya_fms"
        ).toString()
      };

      dispatch(login(formData));
    }
  };

  if (isAuthenticated) {
    toastr.success("Welcome", `Login Successfully`);
    return <Redirect to="/" />;
  }

  return (
    <div className="container-fluid">
      <div className="login-container">
        <div className="card login-form bg-light col-md-8">
          <div className="card-body">
            {/* {loginError && loginError.isError && (
              <span>{loginError.message}</span>
            )} */}
            <form>
              <div className="form-group row">
                <label className="col-sm-2 col-form-label">Email</label>
                <div className="col-sm-10">
                  <input
                    type="email"
                    name="email"
                    onChange={(e) => {
                      setIdentification(e.target.value);
                      setErrors({ ...errors, email: false });
                    }}
                    value={email}
                    id="email"
                    placeholder="Enter email"
                    className={
                      errors.email
                        ? "error form-control login-textfield"
                        : "form-control login-textfield"
                    }
                  />
                  <span
                    className={`login-error-msgField ${
                      errors.email && "show-error-msgField"
                    }`}
                  >
                    Please enter valid email!
                  </span>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-2 col-form-label">Password</label>
                <div className="col-sm-10">
                  <input
                    placeholder="password"
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setErrors({ ...errors, password: false });
                    }}
                    value={password}
                    className={
                      errors.password ? "error form-control" : "form-control"
                    }
                    type={is_visible ? "text" : "password"}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleLogin(e);
                      }
                    }}
                  />
                  <IconButton onClick={() => setIsVisible(!is_visible)}>
                    {is_visible ? (
                      <Visibility color="primary" />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                  <span
                    className={`login-error-msgField ${
                      errors.password && "show-error-msgField"
                    }`}
                  >
                    Please enter valid password!
                  </span>
                </div>
              </div>
              <div className="login-button">
                <button
                  type="button"
                  onClick={handleLogin}
                  className="btn btn-outline-primary"
                >
                  Login
                </button>
                <Link to="/forgot-password">Forgot Password?</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Login);
